import { AfterViewInit, Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { FormlyJsonschema } from '@ngx-formly/core/json-schema';
import { MASKS } from 'ng-brazil';
import { CondicaoDePagamento } from 'src/app/models/condicao-de-pagamento';
import { FormaDePagamento } from 'src/app/models/forma-de-pagamento';
import { CarregandoService } from 'src/app/services/carregando.service';
import { CondicaoDePagamentoService } from 'src/app/services/condicao-de-pagamento.service';
import { FormaDePagamentoService } from 'src/app/services/forma-de-pagamento.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { ViaCepService } from 'src/app/services/via-cep.service';
import {
  ActionDto,
  CreateOrUpdateOrgAppActionRequest,
  OrgAppDto
} from "../../hopper/octopus/client";
import { OctopusService } from "../../services/octopusService";
import { PremissasService } from "../../services/premissas.service";
import { Fornecedor } from "../../models/fornecedor";
import { FornecedorService } from "../../services/fornecedor.service";
import { CRMCanalVenda } from "../../models/crm/crmcanal-venda";
import { PremissasSistema } from "src/app/models/premissas-sistema";

// jquery
declare const $: any;

@Component({
  selector: 'app-cadastrar-forma-de-pagamento',
  templateUrl: './cadastrar-forma-de-pagamento.component.html',
  styleUrls: ['./cadastrar-forma-de-pagamento.component.scss']
})
export class CadastrarFormaDePagamentoComponent implements OnInit {
  // variáveis
  idFormaDePagamento;
  formaDePagamento = new FormaDePagamento();
  editando = false;
  carregando = false;
  public MASKS = MASKS;
  editavel = true;
  padrao = false;
  pegouFranquia = false;
  tipos = [{ id: 0, nome: 'Normal' }, { id: 1, nome: 'Mercado Pago' }];
  status = [{ id: 0, nome: 'Bloqueado' }, { id: 1, nome: 'Ativo' }];
  condicoesDePagamento: CondicaoDePagamento[] = [];

  gatewayOctopus: OrgAppDto[] = [];
  hasGateways = false;
  gatewaySelecionado = null;
  actionsOctopus: ActionDto[] = [];
  actionsSelecionado = null;

  optionsSchema: string = undefined;
  formlyOrgAppActionForm: FormGroup = new FormGroup({});
  formlyOrgAppActionOptions: FormlyFormOptions;
  formlyOrgAppActionFields: FormlyFieldConfig[];
  formlyOrgAppActionModel = {};
  possuiCentroDeDistribuicao = false;
  fornecedores: Fornecedor[] = [];

  premissasSistema = new PremissasSistema();

  constructor(
    private route: ActivatedRoute,
    private notificacaoService: NotificacaoService,
    private formaDePagamentoService: FormaDePagamentoService,
    private router: Router, private viaCepService: ViaCepService,
    private globalService: GlobalService,
    private carregandoService: CarregandoService,
    private condicaoDePagamentoService: CondicaoDePagamentoService,
    private hopperOctopusGiService: OctopusService,
    private premissasService: PremissasService,
    private fornecedorService: FornecedorService,
    private formlyJsonschema: FormlyJsonschema
  ) { }

  ngOnInit() {
    this.buscarPremissas();
    this.buscarPremissasSistema();

    // se for edição, busca o formaDePagamento do id passado
    if (this.route.snapshot.paramMap.get('id')) {
      this.idFormaDePagamento = this.route.snapshot.paramMap.get('id');
      this.editando = true;

      this.buscarFormaDePagamento();
    } else {
      this.formaDePagamento = new FormaDePagamento();
      this.formaDePagamento.tipo = 0;
      this.formaDePagamento.aderirParcelas = true;

      this.buscarGatewayOctopus();
    }

    this.buscarCondicoesDePagamento();
  }

  buscarFormaDePagamento() {
    this.carregandoService.mostra('buscarFormaDePagamento');
    this.carregando = true;

    this.formaDePagamentoService.consultarPorId(this.idFormaDePagamento).subscribe(age => {
      this.formaDePagamento = age;
      this.gatewaySelecionado = this.formaDePagamento.gatewayOctopusId;
      this.actionsSelecionado = this.formaDePagamento.actionOctopusId;

      this.carregandoService.esconde('buscarFormaDePagamento');
      this.carregando = false;

      this.buscarGatewayOctopus();
    }, (erro) => {
      this.carregandoService.esconde('buscarFormaDePagamento');
      this.carregando = false;
      this.notificacaoService.erro(erro);
    });
  }

  buscarCondicoesDePagamento() {
    this.carregandoService.mostra('buscarCondicoesDePagamento');

    this.condicaoDePagamentoService.consultar(1, this.idFormaDePagamento).subscribe((data: any) => {
      this.condicoesDePagamento = data;

      this.carregandoService.esconde('buscarCondicoesDePagamento');
    }, (erro) => {
      this.carregandoService.esconde('buscarCondicoesDePagamento');
      this.notificacaoService.erro(erro);
    });
  }

  buscarGatewayOctopus() {
    if (!this.hopperOctopusGiService.isConfigured()) {
      return;
    }

    this.carregandoService.mostra('buscarGatewayOctopus');

    this.hopperOctopusGiService.client.hubOrgAppListEndpoint(null, 2, null, null, null, null, null).subscribe(data => {
      this.gatewayOctopus = data.result;
      this.hasGateways = data.result.length > 0;

      if (!this.gatewayOctopus.some(g => g.id === this.gatewaySelecionado)) {
        this.gatewaySelecionado = null;
        this.actionsSelecionado = null;
      }

      this.carregandoService.esconde('buscarGatewayOctopus');

      this.buscarActionsOctopus();
    }, (erro) => {
      this.carregandoService.esconde('buscarGatewayOctopus');
      this.notificacaoService.erro('Não foi possível buscar as formas de pagamentos do octopus');
    });
  }

  buscarActionsOctopus() {
    if (!this.hopperOctopusGiService.isConfigured() || this.gatewaySelecionado === null) {
      this.actionsSelecionado = null;
      return;
    }

    this.carregandoService.mostra('buscarActionsOctopus');
    this.hopperOctopusGiService.client.hubOrgAppActionListEndpoint(this.gatewaySelecionado, 101).subscribe(data => {
      this.actionsOctopus = data.result;

      if (!this.actionsOctopus.some(g => g.id === this.actionsSelecionado)) {
        this.actionsSelecionado = null;
      }

      this.carregandoService.esconde('buscarActionsOctopus');
      this.alterarActionOctopus();
    }, (erro) => {
      this.carregandoService.esconde('buscarActionsOctopus');
      this.notificacaoService.erro('Não foi possível buscar as ações do gateway selecionado.');
    });
  }

  alterarActionOctopus() {
    const action = this.actionsOctopus.find(a => a.id === this.actionsSelecionado);

    if (action == null) {
      this.actionsSelecionado = null;
      return;
    }

    if (action.orgAppAction) {
      this.formlyOrgAppActionModel = JSON.parse(action.orgAppAction.optionsModel);
    } else {
      this.formlyOrgAppActionModel = JSON.parse(action.optionsModel);
    }

    this.createOrgAppActionForm(action);
  }

  createOrgAppActionForm(action: ActionDto) {
    this.formlyOrgAppActionForm = new FormGroup({});
    this.formlyOrgAppActionOptions = {};

    this.formlyOrgAppActionFields = [
      this.formlyJsonschema.toFieldConfig(JSON.parse(action.optionsSchema)),
    ];
  }

  salvar() {
    this.carregandoService.mostra('salvaFormaDePagamento');

    if (!this.formaDePagamento.taxa) {
      this.formaDePagamento.taxa = 0;
    }

    this.formaDePagamento.gatewayOctopusId = this.gatewaySelecionado;
    this.formaDePagamento.actionOctopusId = this.actionsSelecionado;
    this.formaDePagamentoService.salvar(this.formaDePagamento).subscribe(() => {
      if (this.hopperOctopusGiService.isConfigured()) {
        this.salvarOrgAppAction();
      }

      this.notificacaoService.sucesso('Forma de pagamento salva com sucesso!!!');
      this.router.navigate(['configuracoes/formas-de-pagamento']).then(() => {
        this.carregandoService.esconde('salvaFormaDePagamento');
      });
    }, (erro) => {
      this.carregandoService.esconde('salvaFormaDePagamento');
      this.notificacaoService.erro(erro);
    });
  }

  salvarOrgAppAction() {
    if (this.gatewaySelecionado !== null && this.actionsSelecionado !== null) {
      this.carregandoService.mostra('salvarOrgAppAction');

      const optionsData = new CreateOrUpdateOrgAppActionRequest({
        optionsModel: JSON.stringify(this.formlyOrgAppActionModel)
      });

      this.hopperOctopusGiService.client.hubOrgAppActionCreateOrUpdateEndpoint(this.gatewaySelecionado, this.actionsSelecionado, optionsData).subscribe(data => {
        this.carregandoService.esconde('salvarOrgAppAction');
      }, (erro) => {
        this.carregandoService.esconde('salvarOrgAppAction');
        this.notificacaoService.erro('Não foi possível enviar a configuração da ação.');
      });
    }
  }

  buscarPremissas() {
    this.carregandoService.mostra('buscarPremissas');

    this.premissasService.consultarCentroDeDistribuicao().subscribe(
      (premissa) => {
        this.possuiCentroDeDistribuicao = premissa.valor;

        if (this.possuiCentroDeDistribuicao) {
          this.buscarFornecedores();
        }

        this.carregandoService.esconde('buscarPremissas');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPremissas');
        this.notificacaoService.erro(erro);
      });
  }

  async buscarPremissasSistema() {
    try {
      this.carregandoService.mostra('buscarPremissasSistema');
      this.premissasSistema = await this.premissasService.consultarPremissasSistema().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPremissasSistema');
    }
  }

  buscarFornecedores() {
    this.carregandoService.mostra('buscarFornecedores');
    this.fornecedorService.consultarFornecedores().subscribe(
      (forn) => {
        this.fornecedores = forn;

        this.carregandoService.esconde('buscarFornecedores');
      },
      (err) => {
        this.carregandoService.esconde('buscarFornecedores');
        this.notificacaoService.erro(err);
      }
    );
  }
}
